import { assets } from '@/ui/assets'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { Permit2SignAction } from './types'

export interface Permit2SignActionRowProps extends ActionRowBaseProps {
  action: Permit2SignAction
}

export function Permit2SignActionRow({
  index,
  action,
  actionHandlerState,
  onAction,
  variant,
}: Permit2SignActionRowProps) {
  const status = actionHandlerState.status

  return (
    <ActionRow index={index}>
      <ActionRow.Icon path={assets.actions.approve} actionStatus={status} />

      <ActionRow.Title icon={<TokenIcon token={action.token} className="h-6" />} actionStatus={status}>
        Sign Permit2 Message
      </ActionRow.Title>

      <ActionRow.Description successMessage="Message signed!" actionStatus={status} variant={variant}>
        Approve {action.token.symbol} spending via Permit2
      </ActionRow.Description>

      <ActionRow.ErrorWarning variant={variant} actionHandlerState={actionHandlerState} />

      <ActionRow.Action onAction={onAction} status={status}>
        Sign
      </ActionRow.Action>
    </ActionRow>
  )
}
